const ITEMS = [
  "$5K guaranteed",
  "Cabinets + granite countertops",
  "Up to 18 cabinets",
  "Kitchen cabinets",
  "Custom bathrooms",
  "Backsplashes & tile",
  "Flooring",
  "Roofing & restoration",
  "Installed in days",
];

export const Marquee = () => (
  <div className="relative overflow-hidden border-b border-ink/10 py-6 sm:py-8" data-testid="editorial-marquee">
    <div className="flex w-max animate-marquee">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
          {ITEMS.map((item) => (
            <span key={`${dup}-${item}`} className="flex items-center gap-8 pr-8">
              <span className="font-display font-medium text-3xl sm:text-5xl tracking-[-0.02em] text-ink whitespace-nowrap">{item}</span>
              <span className="h-2.5 w-2.5 bg-teal shrink-0" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
